import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function PrivacyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="pt-32 pb-24 bg-gray-900">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6">Privacy Policy</h1>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 lg:px-12 py-16">
        <div className="prose prose-lg max-w-none">
          <p className="text-lg text-gray-700 mb-8">
            Hydville ("we", "us", "our") operates hydville.com and is committed to protecting your privacy under EU GDPR regulations.
          </p>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">What Personal Data We Collect</h2>
            <p className="text-gray-700 mb-4">Through our contact form, we collect:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Name</li>
              <li>Email address</li>
              <li>Company name</li>
              <li>Phone number</li>
              <li>Message content</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">How We Use Your Data</h2>
            <p className="text-gray-700">
              We use this information solely to respond to your inquiries. No data is used for marketing, profiling, or shared with third parties without explicit consent.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Legal Basis</h2>
            <p className="text-gray-700">
              Processing is based on your explicit consent (GDPR Article 6(1)(a)) given by checking the consent checkbox in our contact form.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Data Storage &amp; Security</h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Data stored on secure EU-based servers</li>
              <li>Retained only as long as needed to resolve your inquiry (max 12 months)</li>
              <li>Protected by SSL encryption and security measures</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Your Rights (GDPR Chapter III)</h2>
            <p className="text-gray-700 mb-4">You have the right to:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Access your personal data</li>
              <li>Rectify inaccurate data</li>
              <li>Request deletion</li>
              <li>Withdraw consent at any time</li>
              <li>Lodge complaints with supervisory authorities</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Contact Us</h2>
            <p className="text-gray-700">
              For data requests: <a href="mailto:admin@hydville.com" className="text-teal-600 hover:text-teal-700 cursor-pointer">admin@hydville.com</a>
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Changes to This Policy</h2>
            <p className="text-gray-700">
              We may update this policy. Continued use constitutes acceptance of changes.
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
}
